import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import {
    DoctorProfileForDoctorDash,
    profileFetch
} from '../../../../models/Doctorprofile';
import {
    PromiseResult,
    ErrorModel,
    ServerError
} from '../../../../models/PromiseResult';
import { DoctorprofileService } from '../../../../services/doctorprofile.service';
import { Title } from '@angular/platform-browser';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DEFUALT_DOCTOR_IMAGE } from 'src/app/constant/constant';
import { TraceClassDecorator } from '@sentry/angular';
@TraceClassDecorator()
@Component({
    selector: 'app-doctorprofile',
    templateUrl: './doctorprofile.component.html',
    styleUrls: [
        './doctorprofile.component.css',
        '../../../../../assets/css/custom-egd.css'
    ]
})
export class DoctorprofileComponent implements OnInit {
    constructor(
        private readonly doctorProfileService: DoctorprofileService,
        private readonly utilitiesService: UtilitiesService,
        private readonly titleService: Title
    ) {
        this.posting = false;
    }
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    private query: profileFetch;
    profile: DoctorProfileForDoctorDash = null;
    @Input('user_guid')
    private readonly user_guid: string = null;
    defualt_doctor_image: string = DEFUALT_DOCTOR_IMAGE;

    private current_user_guid: string = null;
    async ngOnInit(): Promise<void> {
        this.titleService.setTitle('Dashboard - Doctor Profile');
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        if (this.user_guid == null) {
            this.response = {
                success: false,
                error: {
                    code: '',
                    message: 'User guid is necessary'
                },
                data: null
            };
        }
        this.current_user_guid = sessionStorage.getItem('userid');
        this.query = {
            current_user_guid: this.current_user_guid,
            user_guid: this.user_guid
        };
        if (this.user_guid != null) await this.GetProfile();
    }
    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    private async GetProfile(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        await this.doctorProfileService
            .getDoctorsProfileDataForDoctorDash(this.query)
            .toPromise()
            .then((result: PromiseResult) => {
                this.response = result;

                if (result.success) {
                    this.profile = result.data;
                }
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
    }

    getImageUrl(defualt_url: string, original_url: string): string {
        return this.utilitiesService.getImageUrl(defualt_url, original_url);
    }
}
